export type BibleSearchSetting = "all" | "numbers" | "text";

export interface DropDown {
	id: string;
	name: string;
}

export const BibleSearchSettingsOptions: DropDown[] = [
	{
		id: "all",
		name: "Include verse numbers and notes",
	},
	{
		id: "numbers",
		name: "Include verse numbers",
	},
	{
		id: "text",
		name: "Scripture text only",
	},
];
